<template>
  <div
    class="about-container"
    :class="{
      onDetail: $bowser.mobile && Number(id) > 0,
    }"
  >
    <div
      class="bg"
      :style="{
        height: '100vh',
      }"
    >
      <animated-gradient-bg sign="aboutBg"></animated-gradient-bg>
    </div>
    <div v-if="$bowser.mobile" class="summary__downward-sign-container">
      <div class="down__sign-container">
        <p>slide</p>
        <i class="downward__line"></i>
      </div>
    </div>
    <div class="about-main-body">
      <section class="body__section __summary">
        <div class="section__fixed-container">
          <p class="container__title scrollObj">
            WJID Is A Cutting-edge<br />Interior Design Company
          </p>
          <div class="container__content">
            <p class="scrollObj">{{ companyDesc.cn }}</p>
            <p class="scrollObj">{{ companyDesc.en }}</p>
          </div>
        </div>
        <div
          class="section__scroll-show-container scrollObj"
          v-if="$bowser.mobile"
          data-effect="delay"
          data-offset=""
        >
          <p class="cn">{{ companyDesc.cn }}</p>
          <p class="en">{{ companyDesc.en }}</p>
          <img class="" src="/imgs/about.jpg" alt="" />
        </div>
        <div class="summary__img fr scrollObj"></div>
      </section>
      <section
        class="body__section __creator"
        ref="creatorWrapper"
        :class="{
          onDetailShow: id > 0,
        }"
      >
        <div class="section__title" v-if="$bowser.mobile">
          <p>our team</p>
        </div>
        <div class="creator__container" ref="creatorContainer">
          <div
            class="creator__item scrollObj"
            ref="creator__item"
            :class="{
              hoverShow: !$bowser.mobile,
            }"
            v-for="(item, index) in creators"
            :key="index"
            :data-id="item.id"
            @click="onShowDetail(item.id, index % 2 === 0 ? 'right' : 'left')"
          >
            <div
              class="item__inner"
              @mousemove="textMouseArround"
              @mouseleave="textMouseLeave"
              :data-id="item.id"
            >
              <div class="item__cover">
                <img :src="item.src" alt="" />
              </div>
              <div class="item__name">
                <template v-if="$bowser.mobile">
                  <p>{{ item.name.en }} | {{ item.name.cn }}</p>
                  <p class="item__job">{{ item.job.cn }}</p>
                </template>
                <p v-else>
                  <strong>{{ item.name.en }}</strong> | {{ item.name.cn }}
                </p>
              </div>
              <div
                class="item__mouse-text"
                :class="{
                  show: item.id === showText,
                }"
                :style="{
                  top: item.id === showText ? `${mouseTextPos.y + 10}px` : '0px',
                  left: item.id === showText ? `${mouseTextPos.x + 10}px` : '0px',
                }"
              >
                <p>{{ item.job.en }}</p>
              </div>
            </div>
          </div>
        </div>
        <template v-if="$bowser.mobile">
          <div class="mobile__creator__other-wrapper">
            <div class="creator__other-container">
              <div
                class="other__item scrollObj"
                v-for="member in otherMembers"
                :key="member.id"
                :class="{
                  hoverShow: !$bowser.mobile,
                  mobileActive: $bowser.mobile,
                }"
                @click="$bowser.mobile && onTap(member.id)"
              >
                <div
                  :class="{
                    tapActive: mobileCurrenOtherMemberShow === member.id,
                  }"
                >
                  <div class="cover">
                    <img :src="member.src" alt="" />
                  </div>
                  <div class="info">
                    <p>
                      <strong>{{ member.name.cn }}</strong> | {{ member.title.cn }}
                    </p>
                  </div>
                  <div class="hover__container">
                    <div class="hover__name">{{ member.name.en }}</div>
                    <div class="hover__summary">
                      <p>{{ member.summary.cn }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <template v-if="Number(id) === 0">
            <div
              class="creator__other-container"
              v-for="(group, index) in otherMembers"
              :key="index"
            >
              <div
                class="other__item scrollObj"
                v-for="member in group"
                :key="member.id"
                :class="{
                  hoverShow: !$bowser.mobile,
                  mobileActive: $bowser.mobile,
                }"
              >
                <div class="item__innver">
                  <div class="cover">
                    <img :src="member.src" alt="" />
                  </div>
                  <div class="info">
                    <p>
                      <strong>{{ member.name.cn }}</strong> | {{ member.title.cn }}
                    </p>
                  </div>
                  <div class="hover__container">
                    <div class="hover__name">{{ member.name.en }}</div>
                    <div class="hover__summary">
                      <p>{{ member.summary.cn }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
        <creator-detail
          :id="id"
          :info="detailInfo"
          :theme="creatorDetailTheme"
          @onClose="detailOnClose"
        ></creator-detail>
      </section>
      <section
        class="body__section __brands"
        :style="{
          height: $bowser.mobile ? `${screenHeight}px` : 'auto',
        }"
        v-if="Number(id) === 0"
      >
        <div class="brands-container">
          <div class="container__title">
            <p class="scrollObj">partner</p>
          </div>
          <div class="container__brands-lists">
            <div class="brand__item" v-for="(item, index) in brands" :key="index">
              <div class="item__img-box scrollObj">
                <img class="normal" :src="item.h" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import animatedGradientBg from './_animated-gradient-bg.vue';
import creatorDetail from './_creator-detail.vue';

export default {
  name: 'page-about',
  components: {
    animatedGradientBg,
    creatorDetail,
  },
  data() {
    return {
      creators: [],
      otherMembers: [],
      brands: [
        {
          n: require('@/assets/images/wd/d1/brands/b_1.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_1.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_2.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_2.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_3.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_3.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_4.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_4.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_5.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_5.jpg'),
        },

        {
          n: require('@/assets/images/wd/d1/brands/b_6.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_6.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_7.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_7.jpg'),
        },

        {
          n: require('@/assets/images/wd/d1/brands/b_8.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_8.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_9.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_9.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_10.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_10.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_11.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_11.jpg'),
        },

        {
          n: require('@/assets/images/wd/d1/brands/b_12.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_12.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_13.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_13.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_14.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_14.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_15.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_15.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_16.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_16.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_17.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_17.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_18.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_18.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_19.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_19.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_20.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_20.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_21.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_21.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_22.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_22.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_23.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_23.jpg'),
        },
        {
          n: require('@/assets/images/wd/d1/brands/b_24.jpg'),
          h: require('@/assets/images/wd/d1/brands/bh_24.jpg'),
        },
      ],
      id: 0,
      creatorDetailTheme: '',
      rerender: false,
      mouseTextPos: {
        x: 0,
        y: 0,
      },
      showText: 0,
      requesting: false,
      detailInfo: null,
      mobileCurrenOtherMemberShow: 0,
      companyDesc: {
        cn:
          // eslint-disable-next-line max-len
          `WJID维几设计诞生于2018年，由设计师黄全在上海创立，专注于以艺术的语言表达多元文化在设计中的融合，为客户提供富有文化底蕴、包容多样生活方式的空间解决方案。项目涵盖商业、地产、酒店、办公、私宅、灯光及产品设计等领域。
「几」是维几的设计基因与核心理念，在东方文化中象征着不确定与变革新生，从视觉上看，「几」一扇通向未知的门。维⼏WJID以“为不同变化⽽设计”为使命，崇尚设计的“多元化”与“变化性”，擅于挖掘文化多样性的底色，在过去和当下汲取灵感，呈现现代经典。在全球视野和艺术思维中创作，以“几”之道，打造艺术氛围浓郁、充满情感体验的文化空间。
维几以包容、开放、创新的态度对待每一个项目在历史中传承现代、在多元中创新融合，保持“好奇趋新”的心态，为客户提供整合性的设计策略解决方案，创造更多社会价值。`,
        en:
          // eslint-disable-next-line max-len
          `WJlD was established in 2018 by designer Huang Quan in Shanghai, focusing on expressing the integration of diverse cultures within design through the language of art. It provides clients with space solutions that are rich in cultural heritage and embracing diverse lifestyles. Its project covers the field of commercial spaces, real estate,hotels, offices, mansions, lighting, and product design.The character "几" symbolizes the design gene and core ideology of WJlD, representing uncertainty and innovation in Eastern culture.Visually,"几" serves as a doorway to the unknown. WJlD takes on the mission of "Design for variety" and advocates the principles of"diversity" and "uncertainty" in design, adept at exploring the essence of cultural diversity, drawing inspiration from both the past and the present to demonstrate modern classics. It creates within a global perspective and an artistic mindset, utilizing the path of "几" to craft cultural spaces imbued with a strong artistic atmosphere and emotional experiences.
WJlD approaches each project with an inclusive, open, and innovative attitude, blending modernity with traditions, fostering creativity in diversity while maintaining a mindset of "curious innovation". It offers integrated design strategy solutions that generate greater social value for clients.`,
      },
      scrollTop: 0,
    };
  },
  computed: {
    screenHeight() {
      return window.innerHeight;
    },
  },
  watch: {
    id(val) {
      this.$nextTick(() => {});
      /**
       * 'on-detail': id !== 0 && index + 1 === id,
              'on-hidden': id !== 0 && index + 1 !== id,
       */
      if (val > 0) {
        this.$store.state.mobileAboutDetailOnShow = true;
        this.$refs.creator__item.forEach((item) => {
          const { id } = item.dataset;
          if (Number(id) === Number(val)) {
            item.classList.add('on-detail');
          } else {
            item.classList.add('on-hidden');
          }
        });
      } else {
        this.$store.state.mobileAboutDetailOnShow = false;
        this.$refs.creator__item.forEach((item) => {
          item.classList.remove('on-detail', 'on-hidden');
        });
      }
    },
  },
  mounted() {
    this.getMember();
    this.detailOnClose();
  },
  destroyed() {
    this.detailOnClose();
  },
  methods: {
    detailOnClose() {
      this.id = 0;
      this.detailInfo = null;
      this.rerender = true;
      this.$root.$emit('detailOff');
      if (!this.$bowser.mobile) {
        setTimeout(() => {
          window.scrollTo({
            top: this.scrollTop,
            behavior: 'smooth',
          });
        }, 0);
      }
      document.body.style.cssText = 'overflow:inherit;';
    },
    onShowDetail(id, theme) {
      this.scrollTop = document.documentElement.scrollTop;
      if (this.$bowser.mobile) {
        document.querySelector('.page-header-container').classList.remove('fixed-donw-show');
      } else {
        document.body.style.cssText = 'overflow:hidden;';
        setTimeout(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth',
          });
        }, 0);
      }
      this.$root.$emit('detailOn');
      this.id = id;
      this.detailInfo = this.creators.find((item) => Number(item.id) === Number(id));
      this.creatorDetailTheme = theme;
    },
    textMouseArround(e) {
      this.showText = Number(e.currentTarget.dataset.id);
      this.mouseTextPos = {
        x: e.offsetX,
        y: e.offsetY,
      };
    },
    textMouseLeave() {
      this.showText = 0;
      this.mouseTextPos = {
        x: 0,
        y: 0,
      };
    },
    getMember() {
      const that = this;
      if (!that.requesting) {
        that.requesting = true;
        that.$request
          .get('/api/creator/list')
          .then((res) => {
            let oindex = 0;
            res.data.forEach((item) => {
              if (item.is_fixed) {
                that.creators.push(item);
              } else if (that.$bowser.mobile) {
                that.otherMembers.push(item);
              } else {
                if (that.otherMembers[oindex] === undefined) {
                  that.otherMembers[oindex] = [item];
                } else {
                  that.otherMembers[oindex].push(item);
                }
                if (that.otherMembers[oindex].length >= 4) {
                  oindex += 1;
                }
              }
            });

            that.$nextTick(() => {
              const obj = that.$refs.creatorWrapper;
              let stickyTop = Math.floor(obj.getBoundingClientRect().height) - window.innerHeight;
              stickyTop += parseInt(window.getComputedStyle(obj, null).paddingBottom, 10);
              if (!this.$bowser.mobile) {
                stickyTop += 100;
              }
              obj.style.cssText = `top:-${stickyTop}px`;
            });
          })
          .finally(() => {
            that.requesting = false;
          });
      }
    },
    onTap(memberid) {
      this.mobileCurrenOtherMemberShow = this.mobileCurrenOtherMemberShow === memberid ? 0 : memberid;
    },
  },
};
</script>

<style></style>
